// extracted by mini-css-extract-plugin
export default {"track":"Switch_track__sCHCR","input":"Switch_input__0xs3F","thumb":"Switch_thumb__l+sg9"};